define(function (require) {
    "use strict";
    var CountryCodes = require("infraCodeTables/countryCodes.json");
    var _ = require("underscore");


    var CountryUtility = (function () {

        var translationTable = CountryCodes.translationTable;

        return {

            translate2DigitTo3DigitCode: function (twoDigitCode) {
                if (twoDigitCode) {
                    return translationTable[twoDigitCode.toUpperCase()];
                } else {
                    return null;
                }

            },

            /**
             * @returns {List of all the countries}
             */
            getCountries: function () {
                return CountryCodes.countryCodesArr;
            },

            /**
             * @returns a 3 Digit country code from the full country name
             */
            getCountryCodeByName: function (name) {
                var code= "", country= _.find(CountryCodes.countryCodesArr, {"value": name});
                if(country){
                    code= CountryCodes.translationTable[country.key.toUpperCase()];
                }
                return code;
            },

            /**
             * @returns full country name from 2 Digit country code
             */
            getCountryByKey: function (countryKey) {
                var countryObj = _.find(CountryCodes.countryCodesArr, {"key": countryKey});
                var countryName = '';
                if(countryObj){
                    countryName = countryObj.value;
                }
                return countryName;
            }
        };
    })();
    return CountryUtility;

});
